import { type RefObject, useEffect, useState } from "react";

const useScrollbarWidth = (outerRef: RefObject<HTMLDivElement | null>): number => {
    const [scrollbarWidth, setScrollbarWidth] = useState<number>(0);

    useEffect(() => {
        if (!outerRef.current) return;

        const outer = document.createElement("div");
        Object.assign(outer.style, {
            visibility: "hidden",
            overflow: "scroll",
        });
        outerRef.current.appendChild(outer);

        const inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);

        setScrollbarWidth(outer.offsetWidth - inner.offsetWidth);
        outer.parentNode?.removeChild(outer);
    }, [outerRef.current]);

    return scrollbarWidth;
};

export default useScrollbarWidth;
